import {v4 as uuidv4} from "uuid";

export default class ScheduledTask{
    constructor(taskInput, asyncApi) {
        this.taskInput = taskInput;
        this.lastProgress = null;
        this.result = null;
        this.warnings = [];
        this.metadata = null;

        this.error = null;

        this.clientId = uuidv4();

        this._serverId = '';

        this._endedWithSuccess = false;
        this._cancelled = false;
        this._endedWithError = false;

        this._endResolve = null;
        this._endReject = null;

        this._tsCreated = Date.now();
        this._tsPost = null;
        this._tsFinished = null;
        this._tsLastUpdate = null;
        this._asyncApi = asyncApi;

        this._progressResolve = null;
        this._progressPromise = new Promise(resolve => this._progressResolve = resolve);
    }

    then(resolve, reject = null) {
        if(this._cancelled){
            setTimeout(() => resolve(this.result));
            return;
        }

        if(this._endedWithSuccess){
            setTimeout(() => resolve(this.result));
            return
        }
        if(this._endedWithError){
            if(reject){
                setTimeout(() => reject(this.error));
            }
            return
        }
        this._endResolve = resolve;
        this._endReject = reject;
    }

    cancel(){
        this._asyncApi.requestCancellation(this);
    }

    async *progress() {
        while(true) {
            if(this._cancelled){
                return;
            }

            let progress = await this._progressPromise;
            if (progress == null) {
                return;
            }

            this._progressPromise = new Promise(resolve => this._progressResolve = resolve);
            yield progress;
        }
    }
}